<mat-card class="session-timeout-popup">
    <div class="popup-header">
        <h4 class="popup-title mb-2">Session expiring soon</h4>
        <div class="crossIcon" (click)="onClose()">
            <i mat-dialog-close class="fa fa-times"></i>
        </div>
    </div>

    <div class="popup-body">
        <p>Your session will expire soon. Do you want to extend it?</p>
        <div class="actions mt-3 d-flex justify-content-end">
            <button mat-raised-button color="warn" (click)="onClose()"
                class="btn btn-secondary btn-elevate kt-login__btn-secondary float-right">Close</button>
            <button mat-button color="primary" (click)="onExtend()"
                class="btn btn-primary btn-elevate kt-login__btn-primary ml-2 float-right ml-3">Extend</button>
        </div>
    </div>
</mat-card>